module.exports = __webpack_public_path__ + "static/img/preview-07.e6d88548.webp";